import { render, staticRenderFns } from "./SelectImgForMakePdf.vue?vue&type=template&id=856f96ec&scoped=true"
import script from "./SelectImgForMakePdf.vue?vue&type=script&lang=js"
export * from "./SelectImgForMakePdf.vue?vue&type=script&lang=js"
import style0 from "./SelectImgForMakePdf.vue?vue&type=style&index=0&id=856f96ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856f96ec",
  null
  
)

export default component.exports